import { Requester } from "../../../common/requester";
import { Urls } from "../../../common/urls";

export class FileUploader
{
    private readonly file;
    private isCancelled = false;
    private isFinishedBool = false;
    private hasErrorBool = false;
    private percentDone = 0;
    private reference: string;
    private xhr: XMLHttpRequest;

    constructor(file)
    {
        this.file = file;
    }

    cancel()
    {
        this.isCancelled = true;
        if (this.xhr)
        {
            this.xhr.abort();
        }
    }

    isFinished(): boolean
    {
        return this.isFinishedBool;
    }

    getReference(): string
    {
        return this.reference;
    }

    hasError(): boolean
    {
        return this.hasErrorBool;
    }

    getPercent(): number
    {
        return this.percentDone;
    }

    async upload(onProgress: (percent: number) => void, onError: () => void, onSuccess: () => void)
    {
        const urlData = await Requester.get(Urls.uploadUrl, { fileName: this.file.name });
        this.reference = urlData.Reference;

        const xhr = new XMLHttpRequest();
        this.xhr = xhr;
        xhr.open("PUT", urlData.Url);
        xhr.setRequestHeader("x-amz-storage-class", urlData.StorageClass);
        xhr.setRequestHeader("Content-Type", "binary/octet-stream");

        xhr.upload.addEventListener("progress", (evt) =>
        {
            if (evt.lengthComputable && !this.isCancelled)
            {
                this.percentDone = Math.round((evt.loaded / evt.total) * 100);
                onProgress(this.percentDone);
            }
        });

        xhr.addEventListener("load", () =>
        {
            if (xhr.status >= 200 && xhr.status < 300)
            {
                this.isFinishedBool = true;
                if (!this.isCancelled)
                {
                    onSuccess();
                }
            }
            else if (!this.isCancelled)
            {
                this.hasErrorBool = true;
                onError();
            }
        });

        xhr.addEventListener("error", () =>
        {
            if (!this.isCancelled)
            {
                this.hasErrorBool = true;
                onError();
            }
        });

        xhr.send(this.file);
    }
}
